<template>
  <div class="card p-3 rounded-more user-select-none">
        <div class="d-flex flex-column flex-lg-row gap justify-content-between">
            <div class="d-flex flex-column gap-2x align-items-left order-2 order-lg-1">
                <div>
                    <h3>Join as our representative office</h3>
                    <h5 class="text-md text-secondary">Invite friends to join in trading, by sending your referral code</h5>
                </div>

                <div>
                    <a href="https://wa.me/+6281131186888" class="btn btn-join">Join Now</a>
                </div>
            </div>

            <div class="illustration-section order-1 order-lg-2">
                <img src="@/assets/corporate_frames.png" class="corporate-partner__frames" alt="" />
            </div>
        </div>
  </div>
</template>

<style scoped>
    .btn-join{
        color: white;
        background-color: #005995 !important;
    }
</style>

<script>
export default {
    name : "JoinCorporateCard"
}
</script>